const AppContainer = (props: any) => {
  return props.children;
};

export default AppContainer;